import { Component, Input } from '@angular/core';
import { Grant } from '../../_models/grant';

@Component({
  moduleId: module.id,
  selector: 'vendorpayment',
  templateUrl: 'vendorpayment.component.html',
  styleUrls: ['vendorpayment.component.css']
})
export class VendorPaymentComponent {
  @Input()
  public grant: Grant;
}




// WEBPACK FOOTER //
// ./src/app/grant-form/vendorpayment/vendorpayment.component.ts